export const ENCRYPT_CPF = false;
